import { createAsyncAction } from "typesafe-actions";

import type { ContactsStatus } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/types";
import type { FetchError } from "app/pages/sales-intelligence/types";

export const fetchContactsStatusAsync = createAsyncAction(
    "@@si/contacts/FETCH_CONTACTS_STATUS_START",
    "@@si/contacts/FETCH_CONTACTS_STATUS_SUCCESS",
    "@@si/contacts/FETCH_CONTACTS_STATUS_FAILURE",
)<void, ContactsStatus, FetchError>();

export const approveContactsTermsAsync = createAsyncAction(
    "@@si/contacts/APPROVE_CONTACTS_TERMS_START",
    "@@si/contacts/APPROVE_CONTACTS_TERMS_SUCCESS",
    "@@si/contacts/APPROVE_CONTACTS_TERMS_FAILURE",
)<void, void, FetchError>();

export const fetchContactsAdmins = createAsyncAction(
    "@@si/common/FETCH_CONTACTS_ADMINS_START",
    "@@si/common/FETCH_CONTACTS_ADMINS_SUCCESS",
    "@@si/common/FETCH_CONTACTS_ADMINS_FAILURE",
)<void, string[], FetchError>();
